/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MeteredUsageInput
 */
export interface MeteredUsageInput {
    /**
     *
     * @type {string}
     * @memberof MeteredUsageInput
     */
    subscriptionItem: string;
    /**
     *
     * @type {number}
     * @memberof MeteredUsageInput
     */
    quantity: number;
}

/**
 * Check if a given object implements the MeteredUsageInput interface.
 */
export function instanceOfMeteredUsageInput(value: object): value is MeteredUsageInput {
    if (!('subscriptionItem' in value) || value['subscriptionItem'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function MeteredUsageInputFromJSON(json: any): MeteredUsageInput {
    return MeteredUsageInputFromJSONTyped(json, false);
}

export function MeteredUsageInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeteredUsageInput {
    if (json == null) {
        return json;
    }
    return {

        'subscriptionItem': json['subscription_item'],
        'quantity': json['quantity'],
    };
}

  export function MeteredUsageInputToJSON(json: any): MeteredUsageInput {
      return MeteredUsageInputToJSONTyped(json, false);
  }

  export function MeteredUsageInputToJSONTyped(value?: MeteredUsageInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'subscription_item': value['subscriptionItem'],
        'quantity': value['quantity'],
    };
}
